module.exports = __webpack_public_path__ + "img/explorer-reader.286f7f90.png";